<template>
    <div class="px-2 flex items-center space-x-2">
        <div v-for="(label, index) in mutableLabels" :key="label.text">
            <label
                class="select-none cursor-pointer inline-flex font-medium items-center mr-1 -ml-1.5 px-1.5 py-0.5 outline-none border border-transparent text-xs leading-4 rounded transition ease-in-out duration-300"
                @click.prevent="selectRadioButton(index)"
                :class="buttonStyling(label, index)">
                <input
                    type="radio"
                    :name="groupName"
                    :value="label.text"
                    v-model="label.isSelected"
                    class="opacity-0 hidden">
                {{ label.text }}
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: "SimpleRadioGroupBlocks",

    props: {
        labels: {
            required: true,
            type: Array,
            Description: "The labels of the radio buttons"
        },
        groupName: {
            required: true,
            type: String,
            Description: "The name to group the radio buttons with"
        },
        backgroundColours: {
            required: true,
            type: Array,
            Description: "The background colour to give the radio buttons when selected, in order. Remember to check if colors are present in webpack whitelist."
        },
        textColours: {
            required: true,
            type: Array,
            Description: "The text colour to give the radio buttons when selected, in order.  Remember to check if colors are present in webpack whitelist."
        },
        unselectedBackgroundColour: {
            required: false,
            type: String,
            default: "gray-100",
            Description: "The default background colour"
        },
        unselectedTextColour: {
            required: false,
            type: String,
            default: "gray-300",
            Description: "The default text colour"
        },
        defaultSelectedItemIndex: {
            required: false,
            type: Number,
            default: -1,
            Description: "Sets the default selected item to this index when mounting the component"
        }
    },

    data () {
        return {
            mutableLabels: [],
        };
    },

    mounted () {
        this.setupMutableLabels();
    },

    computed: {},

    methods: {
        setupMutableLabels () {
            this.labels.forEach((label, index) => {
                this.mutableLabels.push({text: label, isSelected: index === this.defaultSelectedItemIndex, groupName: this.groupName, index: index});
            });
        },

        selectRadioButton (index) {
            let self = this;
            this.mutableLabels.forEach((label) => {
                label.isSelected = label.index === index;
                if (label.isSelected) {
                    self.$emit("input", label.text);
                }
            });
        },

        buttonStyling (label, index) {
            //:class calls this method which loops through every label, adding either selected or unselected styling
            let style = "";
            let backgroundColour = this.backgroundColours.filter((colour, pos) => pos === index);
            if (label.isSelected) {
                style = style + " bg-" + backgroundColour;
            } else {
                style = style + " hover:bg-" + backgroundColour + " hover:text-white bg-" + this.unselectedBackgroundColour;
            }

            let textColour = this.textColours.filter((colour, pos) => pos === index);
            if (label.isSelected) {
                return style + " text-" + textColour;
            } else {
                return style + " hover:text-" + textColour + " hover:text-white text-" + this.unselectedTextColour;
            }
        },
    },
};
</script>
